import React from 'react';
import './style.less';

const source = [
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_5.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_7.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_6.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_11.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_1.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_8.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_12.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_13.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_9.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_2.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_10.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_7.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_3.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_1.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_2.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/img_4.png',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_3.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_4.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_5.gif',
    'https://oss.aircourses.com/web/client/bannerArticle/article1/gif_6.gif',


];
export default function BannerArticlePage1() {
    return <div className="BannerArticlePage">
        <h1>跟哈佛外教学英语！每晚30分钟，养成英语学习好习惯！</h1>
        <img src={source[0]} alt="爱课AirCourse" />
        <p className="mt28">很多孩子上网课还需要全家总动员，爸爸妈妈盯着才能上。而咱们爱课的宝贝们早已养成<em>每晚19:30/20:00准时上爱课，和哈佛外教一起学英语</em>的好习惯，简直都不要太优秀！为宝贝们的自律点赞！ 每天30分钟的课程设置，365天不间断！</p>
        <img className="mt28" src={source[1]} alt="爱课AirCourse" />
        <img className="mt12" src={source[2]} alt="爱课AirCourse" />
        <img className="mt12" src={source[3]} alt="爱课AirCourse" />
        <p className="mt28">不过，好习惯的养成从来都不是一蹴而就的。今天，小爱就来和大家介绍下爱课的小伙伴们是怎么养成自律的好习惯的。</p>
        <img className="imgTitle" src={source[4]} alt="爱课AirCourse" />
        <p className="mt28">好老师对孩子的影响是深远的，遇到自己喜欢的老师，比如咱哈佛外教们，孩子的学习兴趣和效果都会更好！</p>
        <p><em>AirCourse爱课是和哈佛HSA（哈佛大学学生联盟会）合作的语培机构</em>，所有外教均由爱课与哈佛HSA联合甄选培养，水平有保障！</p>
        <img className="mt28" src={source[5]} alt="爱课AirCourse" />
        <p className="mt28">目前，爱课平台上已经汇聚了许多<em>优秀的哈佛明星外教</em>，不仅专业技能强，而且深受孩子们喜爱。</p>
        <div className="flex mt28">
            <section className="bg1" style={{backgroundImage: `url(${source[6]})`}} />
            <p>来自哈佛大学戏剧媒体专业的<em>Jacob老师</em>，因为其富有表演力的教学风格，被大家称为“戏精老师”，收获了一票小粉丝。</p>
        </div>
        <div className="flex mt12">
            <section className="bg2" style={{backgroundImage: `url(${source[7]})`}} />
            <p>哈佛各类奖学金拿到手软的超级学霸<em>Yanet老师</em>，学习成绩优异，一直从事少儿教育工作，对待小朋友有使不完的绝招，大家都称呼她为“最美老师”。</p>
        </div>
        <p className="mt28">让世界上最会学习的学霸教娃学习，你还有什么不放心的呢！此外，每一堂外教课，<em>具体到外教的发音、语速、手势、表情等</em>，爱课教研团队都会和外教们反复确认、打磨，确保呈献给最好的课堂教学结果！我们的教研团队也很牛逼哦！</p>
        <img className="mt28" src={source[8]} alt="爱课AirCourse" />
        <p className="mt28">我们相信，认真负责的老师才能给孩子们最好的教育，不辜负每天准点来上课的宝贝们呀~</p>
        <img className="imgTitle" src={source[9]} alt="爱课AirCourse" />
        <p className="mt28">哈佛外教百科英语是Al互动课，1V4课堂的。还有<em>好友组队功能</em>，可以邀请自己的小伙伴一起上课，让上课变得充满仪式感！</p>
        <p>除了可以和好友一起组队上课，哈佛外教百科英语通过全新的智能互动课堂，可以有效地提高孩子上课的注意力、竞争力、积极性。</p>
        <p>每节课都是以场景动画开始引入，内容设置有趣，哪个孩子不爱呢？</p>
        <img className="mt28" src={source[10]} alt="爱课AirCourse" />
        <p className="mt28">课堂过程中外教还会采用场景式教学，鼓励孩子开口说英语。<em>同伴竞答、游戏PK</em>的形式来激励孩子，答对题还可以赢得钻石，答对的越多，参加互动越积极，获得的钻石也越多！孩子学习积极性自然很高了！</p>

        <img className="mt28" src={source[11]} alt="爱课AirCourse" />
        <img className="imgTitle" src={source[12]} alt="爱课AirCourse" />
        <p className="mt28">作为一门英语知识拓展课，哈佛外教百科英语每天都会有特定的<em>主题课程</em>（365天每天不重样），这些主题课程全都是参考美国原版教材的，内容涵盖<em>生命科学、自然地理、人文艺术等各方面百科知识</em></p>

        <img className="mt28" src={source[13]} alt="爱课AirCourse" />
        <p className="mt28">而且，这些主题课的内容都非常的<em>实用接地气</em>，涵盖各种日常生活场景的实用语句、各类百科知识，常见的节日、文化等。</p>

        <img className="mt28" src={source[14]} alt="爱课AirCourse" />
        <p className="mt28">每天都能学习到新的有趣的知识，会不断驱动着孩子探索学习，孩子会很期待每天的课程内容，学习的主动性就上来了~这大概便是“兴趣是最大的学习动力”了！</p>

        <img className="imgTitle" src={source[15]} alt="爱课AirCourse" />
        <p className="mt28">为了能够保证孩子们最大化的学习效果，哈佛外教百科英语的课程设计也是相当科学的哦~<em>通过打造“课前-课中-课后”的学习闭环，帮助孩子养成学习的正确姿势！</em></p>
        <p><em>先预习，再听课，再复习</em>，这样的学习习惯养成后，对孩子的学习会有很大的帮助~</p>
        <img className="mt28" src={source[16]} alt="爱课AirCourse" />
        <p className="mt28">然后是<em>课堂直播学习</em>，外教老师会通过各种互动来为孩子们创造开口说的机会，鼓励孩子开口说英语，听说结合帮助大家加深记忆。</p>
        <img className="mt28" src={source[17]} alt="爱课AirCourse" />
        <p className="mt28">30分钟的课堂学习结束后，还会有<em>课后作业环节</em>。采用AI智能互动游戏的形式，趁热打铁复习所学知识，起到巩固加强的作用。</p>
        <img className="mt28" src={source[18]} alt="爱课AirCourse" />
        <p className="mt28">另外，万一错过了直播课，爱课的<em>“回放”功能</em>，也能帮大家回放学习，学习一点儿不耽误~</p>
        <img className="mt28" src={source[19]} alt="爱课AirCourse" />
        <p className="mt28">“课前-课中-课后”的完美学习闭环，助力孩子英语水平蹭蹭蹭上升！</p>
        <p>最后，小爱想说的是：<em>优秀其实是一种习惯，上爱课哈佛外教百科英语，养成自律好习惯！让我们一起实现英语弯道超车！</em></p>

    </div>
}


// WEBPACK FOOTER //
// ./src/components/bannerArticle/page1.jsx